export type Language = 'es' | 'en' | 'ca';

export const translations = {
  es: {
    // Header
    appTitle: 'MedAI Cite',
    mySearches: 'Mis búsquedas',
    logout: 'Cerrar sesión',
    login: 'Iniciar sesión',
    upgradePlan: 'Mejora tu plan',
    
    // Index page
    subtitle: 'Encuentra soporte científico para tus afirmaciones médicas',
    searchResults: 'Resultados de la búsqueda',
    articlesFound: 'artículo',
    articlesFoundPlural: 'artículos',
    found: 'encontrado',
    foundPlural: 'encontrados',
    saveSearch: 'Guardar búsqueda',
    findNewArticles: 'Cerca articles nous sobre aquest tema 🔄',
    developedWith: 'Desarrollado con Lovable e IA para mejorar la investigación médica',
    unlockUnlimited: 'Desbloquea búsquedas ilimitadas, guardado permanente y más con nuestros planes Premium',
    viewPlans: 'Ver planes',
    limitReached: 'Límite alcanzado',
    
    // SearchBox
    enterStatement: 'Introduce tu afirmación médica',
    examplePlaceholder: 'Ejemplo: "La luxación de las prótesis de cadera tiene una frecuencia considerable"',
    yearFrom: 'Año desde',
    yearTo: 'Año hasta',
    studyType: 'Tipo de estudio',
    allTypes: 'Todos',
    clinicalTrial: 'Ensayo clínico',
    review: 'Revisión',
    metaAnalysis: 'Metaanálisis',
    systematicReview: 'Revisión sistemática',
    searching: 'Buscando...',
    searchButton: 'Buscar soporte bibliográfico',
    
    // ResultCard
    articleContext: 'Contexto del artículo',
    relevantSnippet: 'Fragmento relevante:',
    reference: 'Referencia bibliográfica (Vancouver):',
    copied: 'Copiado',
    copyReference: 'Copiar referencia',
    export: 'Exportar',
    viewArticle: 'Ver artículo',
    articleHelpful: '¿Te ha sido útil este artículo?',
    feedbackThanks: '¡Gracias por tu opinión!',
    feedbackHelpsImprove: 'Tu valoración nos ayuda a mejorar.',
    translate: 'Traducir',
    viewOriginal: 'Ver original',
    autoTranslated: 'Traducido automáticamente con IA',
    translating: 'Traduciendo...',
    translationError: 'Error al traducir',
    translationErrorDescription: 'No se pudo traducir el texto. Por favor, intenta de nuevo.',
    
    // Auth
    welcome: 'Bienvenido a MedAI Cite',
    authDescription: 'Inicia sesión o crea una cuenta para guardar tus búsquedas',
    email: 'Email',
    password: 'Contraseña',
    signIn: 'Iniciar sesión',
    signUp: 'Crear cuenta',
    dontHaveAccount: '¿No tienes cuenta?',
    alreadyHaveAccount: '¿Ya tienes cuenta?',
    forgotPassword: '¿Has olvidado la contraseña?',
    forgotPasswordTitle: 'Restablecer contraseña',
    forgotPasswordDescription: 'Introduce tu correo para restablecer la contraseña.',
    sendResetLink: 'Enviar enlace',
    resetLinkSent: 'Correo enviado',
    resetLinkSentDescription: 'Te hemos enviado un correo con el enlace para restablecerla.',
    backToLogin: 'Volver al login',
    resetPasswordTitle: 'Nueva contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirma la nueva contraseña',
    saveChanges: 'Guardar cambios',
    passwordUpdated: 'Contraseña actualizada',
    passwordUpdatedDescription: 'Tu contraseña se ha actualizado correctamente.',
    redirectingToLogin: 'Redirigiendo al login...',
    passwordsMustMatch: 'Las contraseñas deben coincidir',
    invalidOrExpiredToken: 'El enlace ha caducado o no es válido',
    
    // SavedSearches
    savedSearchesTitle: 'Mis búsquedas guardadas',
    noSavedSearches: 'No tienes búsquedas guardadas',
    noSavedSearchesDescription: 'Realiza búsquedas y guárdalas para acceder rápidamente a ellas',
    backToSearch: 'Volver a buscar',
    filters: 'Filtros',
    rerun: 'Ejecutar',
    delete: 'Eliminar',
    
    // Toasts
    searchProcessing: 'Procesando búsqueda...',
    searchProcessingDescription: 'Estamos buscando los mejores artículos para ti',
    searchCompleted: 'Resultados actualizados correctamente ✅',
    resultsFound: 'Se encontraron',
    results: 'resultados',
    noResults: 'Sin resultados',
    noResultsDescription: 'No se encontraron artículos para esta búsqueda. Intenta con otros términos.',
    searchError: 'Error en la búsqueda',
    searchErrorDescription: 'Ocurrió un error al buscar. Por favor, intenta de nuevo.',
    loginRequired: 'Inicia sesión',
    loginRequiredDescription: 'Debes iniciar sesión para guardar búsquedas',
    authRequiredSearch: '❌ Debes iniciar sesión para poder realizar una búsqueda.',
    authRequiredSearchLink: 'Inicia sesión aquí',
    noSearchToSave: 'Sin búsqueda',
    noSearchToSaveDescription: 'Realiza una búsqueda primero para poder guardarla',
    searchSaved: 'Búsqueda guardada',
    searchSavedDescription: 'La búsqueda ha sido guardada correctamente',
    saveError: 'Error',
    saveErrorDescription: 'No se pudo guardar la búsqueda',
    referenceCopied: 'Referencia copiada',
    referenceCopiedDescription: 'La referencia ha sido copiada al portapapeles',
    copyError: 'Error',
    copyErrorDescription: 'No se pudo copiar la referencia',
    referenceExported: 'Referencia exportada',
    referenceExportedDescription: 'La referencia ha sido descargada en formato',
    searchDeleted: 'Búsqueda eliminada',
    searchDeletedDescription: 'La búsqueda ha sido eliminada correctamente',
    deleteError: 'Error',
    deleteErrorDescription: 'No se pudo eliminar la búsqueda',
    authError: 'Error de autenticación',
    signInSuccess: 'Sesión iniciada',
    signInSuccessDescription: 'Has iniciado sesión correctamente',
    signUpSuccess: 'Cuenta creada',
    signUpSuccessDescription: 'Tu cuenta ha sido creada. Revisa tu email para confirmarla.',
    activeSubscriptionError: 'Ya tienes un plan activo',
    activeSubscriptionErrorDescription: 'Cancela el actual antes de comprar otro.',
    
    // Pricing
    plans: 'Planes',
    choosePlan: 'Elige tu plan ideal para tu práctica médica',
    findPerfectPlan: 'Encuentra el plan perfecto para tus necesidades de investigación médica',
    mostPopular: 'Más popular',
    bestOption: 'Mejor opción',
    yourPlan: 'Tu plan',
    currentPlan: 'Plan actual',
    upgradeToPlan: 'Mejora tu plan a',
    viewPlan: 'Ver plan',
    manageSubscription: 'Gestionar mi suscripción',
    free: 'Gratuito',
    adminPlan: 'Administrador (acceso ilimitado)',
    perMonth: '/mes',
    searchesPerDay: 'búsquedas al día',
    maxSearchesPerMonth: 'Máximo {count} búsquedas al mes',
    savedResultsPerDay: 'resultado guardado al día (se elimina en 30 días)',
    savedResultsPermanent: 'Hasta {count} resultados guardados permanentes',
    unlimitedSavedResults: 'Guardado ilimitado y permanente',
    aiReformulatorDaily: 'Reformulador IA: 1 vez al día',
    aiReformulatorUnlimited: 'Reformulador IA: ilimitado',
    citationExportMonthly: 'Exportación de citas: {count} al mes',
    citationExportUnlimited: 'Exportación de citas: ilimitada',
    sourceFilters: 'Filtros por fuente',
    studyTypes: 'Tipos de estudio',
    darkMode: 'Modo oscuro',
    prioritySupport: 'Soporte prioritario',
    prioritySupportEarlyAccess: 'Soporte prioritario y acceso anticipado',
    unlimitedSearches: 'Búsquedas ilimitadas',
    noMonthlyLimit: 'Sin límite mensual',
    checkoutInSpanish: 'El proceso de pago se mostrará en castellano.',
    planBasicSubtitle: 'Ideal para empezar a probar MedAI Cite',
    planBasicDescription: 'Accede a funciones esenciales para consultar información médica fiable y rápida.',
    planBasicHighlight: 'Perfecto para estudiantes o primeros usuarios',
    planBasicTrust: 'Sin coste. Regístrate en segundos.',
    planPlusSubtitle: 'Pensado para médicos y estudiantes que necesitan resultados constantes y fiables',
    planPlusDescription: 'Consulta más citas, con prioridad y mayor velocidad de respuesta.',
    planPlusHighlight: 'Equilibrio perfecto entre rendimiento y coste',
    planPlusTrust: 'Sin límites ocultos ni sorpresas.',
    planProSubtitle: 'La mejor opción para profesionales activos',
    planProDescription: 'Diseñado para médicos que quieren acceso ilimitado, asistencia prioritaria y la máxima fiabilidad.',
    planProHighlight: 'Ideal para presentaciones, investigaciones y uso clínico habitual',
    planProTrust: 'Confianza y rendimiento profesional, cada día.',
    
    // Landing page
    landingNav: {
      login: 'Iniciar Sesión',
      plans: 'Planes',
    },
    landingHero: {
      badge: 'IA para profesionales médicos',
      title: 'Encuentra citas médicas en',
      titleHighlight: 'segundos',
      titleEnd: ', no horas',
      subtitle: 'Escribe una afirmación y obtén artículos y resúmenes fiables en segundos.',
      ctaPrimary: 'Comienza Ahora – Gratuito',
      ctaSecondary: 'Ver Cómo Funciona',
    },
    landingTrust: {
      text: 'Confiada por miles de médicos en todo el mundo',
    },
    landingCalculator: {
      title: 'Calcula Tu Ahorro de Tiempo',
      subtitle: 'Descubre cuánto tiempo puedes recuperar con MedAI Cite',
      searchesLabel: '¿Cuántas citas haces a la semana?',
      searchesPlaceholder: 'Ejemplo: 15',
      minutesLabel: '¿Cuántos minutos tardas por cita?',
      minutesPlaceholder: 'Ejemplo: 15',
      minutesSaved: 'minutos ahorrados por semana',
      freeTime: 'tiempo libre por semana',
      hoursSaved: 'horas ahorradas al mes',
      noData: 'Aún no hay suficientes datos para calcular el ahorro.',
      tryHigher: 'Prueba con valores más altos para ver los resultados.',
    },
    landingBenefits: {
      title: 'Ahorra tiempo y mejora la calidad de tu investigación con IA médica',
      subtitle: 'Tecnología de inteligencia artificial diseñada para profesionales de la salud',
      benefit1Title: 'Citas Automáticas',
      benefit1Desc: 'Genera citas en formato Vancouver o APA automáticamente desde múltiples bases de datos médicas.',
      benefit2Title: 'Fuentes Fiables',
      benefit2Desc: 'Accede a PubMed, Semantic Scholar y CrossRef para obtener la mejor evidencia científica.',
      benefit3Title: 'Exportación Fácil',
      benefit3Desc: 'Exporta tus citas en múltiples formatos e intégralas directamente en tus trabajos.',
      benefit4Title: 'Evita Errores',
      benefit4Desc: 'Reduce errores de citación y asegúrate de que todas las referencias son precisas y actualizadas.',
      testimonialQuote: '"Con MedAI Cite puedo revisar estudios en minutos, no horas."',
      testimonialAuthor: '— Dra. M. López, Barcelona',
    },
    landingHowItWorks: {
      subtitle: 'De la idea al resultado en tres pasos',
      title: 'Cómo Funciona?',
      description: 'Solo tres pasos para encontrar las citas que necesitas',
      step1Title: 'Describe lo que buscas',
      step1Desc: 'Escribe tu pregunta clínica o área de investigación en lenguaje natural.',
      step2Title: 'IA encuentra las mejores fuentes',
      step2Desc: 'Nuestra IA busca en múltiples bases de datos médicas simultáneamente.',
      step3Title: 'Exporta y cita',
      step3Desc: 'Obtén las citas en el formato que necesites y expórtalas a tu documento.',
    },
    landingDemo: {
      title: 'Ejemplo en acción',
      exampleQuery: 'La luxación de prótesis de cadera tiene una frecuencia considerable.',
      badge: 'Ejemplo real — pruébalo con tu propia búsqueda',
      ctaButton: 'Pruébalo con tu búsqueda →',
    },
    landingCta: {
      title: 'Comienza a Ahorrar Tiempo Hoy',
      subtitle: 'Únete a miles de profesionales médicos que ya utilizan MedAI Cite para mejorar su investigación',
      button: 'Comienza Ahora – Gratuito',
    },
    landingFooter: {
      copyright: '© 2025 ActuaAI — Todos los derechos reservados',
      contact: 'Contacta con nosotros',
      developedBy: 'Proyecto desarrollado por ActuaAI para apoyar a los profesionales médicos.',
    },
    trustIndicators: {
      heroSubtext: 'Confiado por estudiantes y profesionales en 20+ países.',
      demoSubtext: 'Creado con el apoyo de estudiantes de medicina y médicos en activo.',
      usageCounter: '🔍 12.500 búsquedas realizadas este mes.',
      designedForTitle: 'Diseñado para...',
      forWhoTitle: '¿Para quién es?',
      audience1: 'Estudiantes de medicina',
      audience2: 'Médicos residentes',
      audience3: 'Médicos especialistas',
      audience4: 'Investigadores y docentes',
      finalText: 'Ideal para presentaciones, trabajos clínicos y revisión rápida de evidencia.',
    },
  },
  en: {
    // Header
    appTitle: 'MedAI Cite',
    mySearches: 'My searches',
    logout: 'Log out',
    login: 'Log in',
    upgradePlan: 'Upgrade your plan',
    
    // Index page
    subtitle: 'Find scientific support for your medical statements',
    searchResults: 'Search results',
    articlesFound: 'article',
    articlesFoundPlural: 'articles',
    found: 'found',
    foundPlural: 'found',
    saveSearch: 'Save search',
    findNewArticles: 'Find new articles on this topic 🔄',
    developedWith: 'Developed with Lovable and AI to improve medical research',
    unlockUnlimited: 'Unlock unlimited searches, permanent storage and more with our Premium plans',
    viewPlans: 'View plans',
    limitReached: 'Limit reached',
    
    // SearchBox
    enterStatement: 'Enter your medical statement',
    examplePlaceholder: 'Example: "Hip prosthesis dislocation has a considerable frequency"',
    yearFrom: 'Year from',
    yearTo: 'Year to',
    studyType: 'Study type',
    allTypes: 'All',
    clinicalTrial: 'Clinical trial',
    review: 'Review',
    metaAnalysis: 'Meta-analysis',
    systematicReview: 'Systematic review',
    searching: 'Searching...',
    searchButton: 'Search bibliographic support',
    
    // ResultCard
    articleContext: 'Article context',
    relevantSnippet: 'Relevant snippet:',
    reference: 'Bibliographic reference (Vancouver):',
    copied: 'Copied',
    copyReference: 'Copy reference',
    export: 'Export',
    viewArticle: 'View article',
    articleHelpful: 'Was this article helpful?',
    feedbackThanks: 'Thanks for your feedback!',
    feedbackHelpsImprove: 'Your feedback helps us improve.',
    translate: 'Translate',
    viewOriginal: 'View original',
    autoTranslated: 'Automatically translated with AI',
    translating: 'Translating...',
    translationError: 'Translation error',
    translationErrorDescription: 'Could not translate the text. Please try again.',
    
    // Auth
    welcome: 'Welcome to MedAI Cite',
    authDescription: 'Sign in or create an account to save your searches',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    forgotPassword: 'Forgot your password?',
    forgotPasswordTitle: 'Reset Password',
    forgotPasswordDescription: 'Enter your email to reset your password.',
    sendResetLink: 'Send Reset Link',
    resetLinkSent: 'Email Sent',
    resetLinkSentDescription: "We've sent you an email with a link to reset your password.",
    backToLogin: 'Back to Login',
    resetPasswordTitle: 'New Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    saveChanges: 'Save Changes',
    passwordUpdated: 'Password Updated',
    passwordUpdatedDescription: 'Your password has been updated successfully.',
    redirectingToLogin: 'Redirecting to login...',
    passwordsMustMatch: 'Passwords must match',
    invalidOrExpiredToken: 'The link has expired or is invalid',
    
    // SavedSearches
    savedSearchesTitle: 'My saved searches',
    noSavedSearches: 'You have no saved searches',
    noSavedSearchesDescription: 'Perform searches and save them to access them quickly',
    backToSearch: 'Back to search',
    filters: 'Filters',
    rerun: 'Run',
    delete: 'Delete',
    
    // Toasts
    searchProcessing: 'Processing search...',
    searchProcessingDescription: 'We are searching the best articles for you',
    searchCompleted: 'Results updated successfully ✅',
    resultsFound: 'Found',
    results: 'results',
    noResults: 'No results',
    noResultsDescription: 'No articles found for this search. Try with other terms.',
    searchError: 'Search error',
    searchErrorDescription: 'An error occurred while searching. Please try again.',
    loginRequired: 'Login required',
    loginRequiredDescription: 'You must log in to save searches',
    authRequiredSearch: '❌ You must log in before making a search.',
    authRequiredSearchLink: 'Log in here',
    noSearchToSave: 'No search',
    noSearchToSaveDescription: 'Perform a search first to be able to save it',
    searchSaved: 'Search saved',
    searchSavedDescription: 'The search has been saved successfully',
    saveError: 'Error',
    saveErrorDescription: 'Could not save the search',
    referenceCopied: 'Reference copied',
    referenceCopiedDescription: 'The reference has been copied to the clipboard',
    copyError: 'Error',
    copyErrorDescription: 'Could not copy the reference',
    referenceExported: 'Reference exported',
    referenceExportedDescription: 'The reference has been downloaded in format',
    searchDeleted: 'Search deleted',
    searchDeletedDescription: 'The search has been deleted successfully',
    deleteError: 'Error',
    deleteErrorDescription: 'Could not delete the search',
    authError: 'Authentication error',
    signInSuccess: 'Signed in',
    signInSuccessDescription: 'You have successfully signed in',
    signUpSuccess: 'Account created',
    signUpSuccessDescription: 'Your account has been created. Check your email to confirm it.',
    activeSubscriptionError: 'You already have an active plan',
    activeSubscriptionErrorDescription: 'Cancel your current plan before purchasing another.',
    
    // Pricing
    plans: 'Plans',
    choosePlan: 'Choose your ideal plan for your medical practice',
    findPerfectPlan: 'Find the perfect plan for your medical research needs',
    mostPopular: 'Most popular',
    bestOption: 'Best choice',
    yourPlan: 'Your plan',
    currentPlan: 'Current plan',
    upgradeToPlan: 'Upgrade your plan to',
    viewPlan: 'View plan',
    manageSubscription: 'Manage my subscription',
    free: 'Free',
    adminPlan: 'Administrator (unlimited access)',
    perMonth: '/month',
    searchesPerDay: 'searches per day',
    maxSearchesPerMonth: 'Maximum {count} searches per month',
    savedResultsPerDay: 'saved result per day (deleted after 30 days)',
    savedResultsPermanent: 'Up to {count} permanently saved results',
    unlimitedSavedResults: 'Unlimited and permanent storage',
    aiReformulatorDaily: 'AI Reformulator: once a day',
    aiReformulatorUnlimited: 'AI Reformulator: unlimited',
    citationExportMonthly: 'Citation export: {count} per month',
    citationExportUnlimited: 'Citation export: unlimited',
    sourceFilters: 'Source filters',
    studyTypes: 'Study types',
    darkMode: 'Dark mode',
    prioritySupport: 'Priority support',
    prioritySupportEarlyAccess: 'Priority support and early access',
    unlimitedSearches: 'Unlimited searches',
    noMonthlyLimit: 'No monthly limit',
    checkoutInSpanish: 'The payment process will be displayed in Spanish.',
    planBasicSubtitle: 'Ideal to start trying MedAI Cite',
    planBasicDescription: 'Access essential features to query reliable and fast medical information.',
    planBasicHighlight: 'Perfect for students or first-time users',
    planBasicTrust: 'No cost. Register in seconds.',
    planPlusSubtitle: 'Designed for doctors and students who need consistent and reliable results',
    planPlusDescription: 'Search more citations, with priority and faster response times.',
    planPlusHighlight: 'Perfect balance between performance and cost',
    planPlusTrust: 'No hidden limits or surprises.',
    planProSubtitle: 'The best option for active professionals',
    planProDescription: 'Designed for doctors who want unlimited access, priority assistance and maximum reliability.',
    planProHighlight: 'Ideal for presentations, research and regular clinical use',
    planProTrust: 'Professional trust and performance, every day.',
    
    // Landing page
  landingNav: {
    login: 'Log In',
    plans: 'Plans',
  },
    landingHero: {
      badge: 'AI for medical professionals',
      title: 'Find medical citations in',
      titleHighlight: 'seconds',
      titleEnd: ', not hours',
      subtitle: 'Write a statement and get reliable articles and summaries in seconds.',
      ctaPrimary: 'Start Now – Free',
      ctaSecondary: 'See How It Works',
    },
    landingTrust: {
      text: 'Trusted by thousands of doctors worldwide',
    },
    landingCalculator: {
      title: 'Calculate Your Time Savings',
      subtitle: 'Discover how much time you can save with MedAI Cite',
      searchesLabel: 'How many citations do you make per week?',
      searchesPlaceholder: 'Example: 15',
      minutesLabel: 'How many minutes per citation?',
      minutesPlaceholder: 'Example: 15',
      minutesSaved: 'minutes saved per week',
      freeTime: 'free time per week',
      hoursSaved: 'hours saved per month',
      noData: 'Not enough data yet to calculate savings.',
      tryHigher: 'Try higher values to see results.',
    },
    landingBenefits: {
      title: 'Save time and improve your research quality with medical AI',
      subtitle: 'Artificial intelligence technology designed for healthcare professionals',
      benefit1Title: 'Automatic Citations',
      benefit1Desc: 'Generate citations in Vancouver or APA format automatically from multiple medical databases.',
      benefit2Title: 'Reliable Sources',
      benefit2Desc: 'Access PubMed, Semantic Scholar and CrossRef to get the best scientific evidence.',
      benefit3Title: 'Easy Export',
      benefit3Desc: 'Export your citations in multiple formats and integrate them directly into your work.',
      benefit4Title: 'Avoid Errors',
      benefit4Desc: 'Reduce citation errors and ensure all references are accurate and up-to-date.',
      testimonialQuote: '"With MedAI Cite I can review studies in minutes, not hours."',
      testimonialAuthor: '— Dr. M. López, Barcelona',
    },
    landingHowItWorks: {
      subtitle: 'From idea to result in three steps',
      title: 'How Does It Work?',
      description: 'Just three steps to find the citations you need',
      step1Title: 'Describe what you\'re looking for',
      step1Desc: 'Write your clinical question or research area in natural language.',
      step2Title: 'AI finds the best sources',
      step2Desc: 'Our AI searches multiple medical databases simultaneously.',
      step3Title: 'Export and cite',
      step3Desc: 'Get citations in the format you need and export them to your document.',
    },
    landingDemo: {
      title: 'Example in action',
      exampleQuery: 'Hip prosthesis dislocation has a considerable frequency.',
      badge: 'Real example — try it with your own search',
      ctaButton: 'Try it with your search →',
    },
    landingCta: {
      title: 'Start Saving Time Today',
      subtitle: 'Join thousands of medical professionals already using MedAI Cite to improve their research',
      button: 'Start Now – Free',
    },
    landingFooter: {
      copyright: '© 2025 ActuaAI — All rights reserved',
      contact: 'Contact us',
      developedBy: 'Project developed by ActuaAI to support medical professionals.',
    },
    trustIndicators: {
      heroSubtext: 'Trusted by students and professionals in 20+ countries.',
      demoSubtext: 'Created with the support of medical students and practicing physicians.',
      usageCounter: '🔍 12,500 searches performed this month.',
      designedForTitle: 'Designed for...',
      forWhoTitle: 'Who is it for?',
      audience1: 'Medical students',
      audience2: 'Resident doctors',
      audience3: 'Specialist doctors',
      audience4: 'Researchers and educators',
      finalText: 'Ideal for presentations, clinical papers, and quick evidence review.',
    },
  },
  ca: {
    // Header
    appTitle: 'MedAI Cite',
    mySearches: 'Les meves cerques',
    logout: 'Tancar sessió',
    login: 'Iniciar sessió',
    upgradePlan: 'Millora el teu pla',
    
    // Index page
    subtitle: 'Troba suport científic per a les teves afirmacions mèdiques',
    searchResults: 'Resultats de la cerca',
    articlesFound: 'article',
    articlesFoundPlural: 'articles',
    found: 'trobat',
    foundPlural: 'trobats',
    saveSearch: 'Desar cerca',
    findNewArticles: 'Cerca articles nous sobre aquest tema 🔄',
    developedWith: 'Desenvolupat amb Lovable i IA per millorar la recerca mèdica',
    unlockUnlimited: 'Desbloqueja cerques il·limitades, desat permanent i més amb els nostres plans Premium',
    viewPlans: 'Veure plans',
    limitReached: 'Límit assolit',
    
    // SearchBox
    enterStatement: 'Introdueix la teva afirmació mèdica',
    examplePlaceholder: 'Exemple: "La luxació de les pròtesis de maluc té una freqüència considerable"',
    yearFrom: 'Any des de',
    yearTo: 'Any fins',
    studyType: 'Tipus d\'estudi',
    allTypes: 'Tots',
    clinicalTrial: 'Assaig clínic',
    review: 'Revisió',
    metaAnalysis: 'Metaanàlisi',
    systematicReview: 'Revisió sistemàtica',
    searching: 'Cercant...',
    searchButton: 'Cercar suport bibliogràfic',
    
    // ResultCard
    articleContext: 'Context de l\'article',
    relevantSnippet: 'Fragment rellevant:',
    reference: 'Referència bibliogràfica (Vancouver):',
    copied: 'Copiat',
    copyReference: 'Copiar referència',
    export: 'Exportar',
    viewArticle: 'Veure article',
    articleHelpful: 'T\'ha estat útil aquest article?',
    feedbackThanks: 'Gràcies per la teva opinió!',
    feedbackHelpsImprove: 'La teva valoració ens ajuda a millorar.',
    translate: 'Traduir',
    viewOriginal: 'Veure original',
    autoTranslated: 'Traduït automàticament amb IA',
    translating: 'Traduint...',
    translationError: 'Error en traduir',
    translationErrorDescription: 'No s\'ha pogut traduir el text. Si us plau, torna-ho a provar.',
    
    // Auth
    welcome: 'Benvingut a MedAI Cite',
    authDescription: 'Inicia sessió o crea un compte per desar les teves cerques',
    email: 'Email',
    password: 'Contrasenya',
    signIn: 'Iniciar sessió',
    signUp: 'Crear compte',
    dontHaveAccount: 'No tens compte?',
    alreadyHaveAccount: 'Ja tens compte?',
    forgotPassword: 'Has oblidat la contrasenya?',
    forgotPasswordTitle: 'Restablir contrasenya',
    forgotPasswordDescription: 'Introdueix el teu correu per restablir la contrasenya.',
    sendResetLink: 'Enviar enllaç',
    resetLinkSent: 'Correu enviat',
    resetLinkSentDescription: 'T\'hem enviat un correu amb l\'enllaç per restablir-la.',
    backToLogin: 'Torna al login',
    resetPasswordTitle: 'Nova contrasenya',
    newPassword: 'Nova contrasenya',
    confirmPassword: 'Confirma la nova contrasenya',
    saveChanges: 'Desa els canvis',
    passwordUpdated: 'Contrasenya actualitzada',
    passwordUpdatedDescription: 'La teva contrasenya s\'ha actualitzat correctament.',
    redirectingToLogin: 'Redirigint al login...',
    passwordsMustMatch: 'Les contrasenyes han de coincidir',
    invalidOrExpiredToken: 'L\'enllaç ha caducat o no és vàlid',
    
    // SavedSearches
    savedSearchesTitle: 'Les meves cerques desades',
    noSavedSearches: 'No tens cerques desades',
    noSavedSearchesDescription: 'Realitza cerques i desa-les per accedir-hi ràpidament',
    backToSearch: 'Tornar a cercar',
    filters: 'Filtres',
    rerun: 'Executar',
    delete: 'Eliminar',
    
    // Toasts
    searchProcessing: 'S\'està processant la teva cerca...',
    searchProcessingDescription: 'Estem cercant els millors articles per a tu',
    searchCompleted: 'Resultats actualitzats correctament ✅',
    resultsFound: 'S\'han trobat',
    results: 'resultats',
    noResults: 'Sense resultats',
    noResultsDescription: 'No s\'han trobat articles per a aquesta cerca. Prova amb altres termes.',
    searchError: 'Error en la cerca',
    searchErrorDescription: 'S\'ha produït un error en cercar. Si us plau, torna-ho a provar.',
    loginRequired: 'Inicia sessió',
    loginRequiredDescription: 'Has d\'iniciar sessió per desar cerques',
    authRequiredSearch: '❌ Has d\'iniciar sessió per poder fer una recerca.',
    authRequiredSearchLink: 'Inicia sessió aquí',
    noSearchToSave: 'Sense cerca',
    noSearchToSaveDescription: 'Realitza una cerca primer per poder-la desar',
    searchSaved: 'Cerca desada',
    searchSavedDescription: 'La cerca s\'ha desat correctament',
    saveError: 'Error',
    saveErrorDescription: 'No s\'ha pogut desar la cerca',
    referenceCopied: 'Referència copiada',
    referenceCopiedDescription: 'La referència s\'ha copiat al porta-retalls',
    copyError: 'Error',
    copyErrorDescription: 'No s\'ha pogut copiar la referència',
    referenceExported: 'Referència exportada',
    referenceExportedDescription: 'La referència s\'ha descarregat en format',
    searchDeleted: 'Cerca eliminada',
    searchDeletedDescription: 'La cerca s\'ha eliminat correctament',
    deleteError: 'Error',
    deleteErrorDescription: 'No s\'ha pogut eliminar la cerca',
    authError: 'Error d\'autenticació',
    signInSuccess: 'Sessió iniciada',
    signInSuccessDescription: 'Has iniciat sessió correctament',
    signUpSuccess: 'Compte creat',
    signUpSuccessDescription: 'El teu compte s\'ha creat. Revisa el teu email per confirmar-lo.',
    activeSubscriptionError: 'Ja tens un pla actiu',
    activeSubscriptionErrorDescription: 'Cancel·la l\'actual abans de comprar-ne un altre.',
    
    // Pricing
    plans: 'Plans',
    choosePlan: 'Tria el teu pla ideal per a la teva pràctica mèdica',
    findPerfectPlan: 'Troba el pla perfecte per a les teves necessitats de recerca mèdica',
    mostPopular: 'Més popular',
    bestOption: 'Millor opció',
    yourPlan: 'El teu pla',
    currentPlan: 'Pla actual',
    upgradeToPlan: 'Millora el teu pla a',
    viewPlan: 'Veure pla',
    manageSubscription: 'Gestionar la meva subscripció',
    free: 'Gratuït',
    adminPlan: 'Administrador (accés il·limitat)',
    perMonth: '/mes',
    searchesPerDay: 'cerques al dia',
    maxSearchesPerMonth: 'Màxim {count} cerques al mes',
    savedResultsPerDay: 'resultat desat al dia (s\'elimina en 30 dies)',
    savedResultsPermanent: 'Fins a {count} resultats desats permanents',
    unlimitedSavedResults: 'Desat il·limitat i permanent',
    aiReformulatorDaily: 'Reformulador IA: 1 vegada al dia',
    aiReformulatorUnlimited: 'Reformulador IA: il·limitat',
    citationExportMonthly: 'Exportació de cites: {count} al mes',
    citationExportUnlimited: 'Exportació de cites: il·limitada',
    sourceFilters: 'Filtres per font',
    studyTypes: 'Tipus d\'estudi',
    darkMode: 'Mode fosc',
    prioritySupport: 'Suport prioritari',
    prioritySupportEarlyAccess: 'Suport prioritari i accés anticipat',
    unlimitedSearches: 'Cerques il·limitades',
    noMonthlyLimit: 'Sense límit mensual',
    checkoutInSpanish: 'El procés de pagament es mostrarà en castellà.',
    planBasicSubtitle: 'Ideal per començar a provar MedAI Cite',
    planBasicDescription: 'Accedeix a funcions essencials per consultar informació mèdica fiable i ràpida.',
    planBasicHighlight: 'Perfecte per a estudiants o primers usuaris',
    planBasicTrust: 'Sense cost. Registra\'t en segons.',
    planPlusSubtitle: 'Pensat per metges i estudiants que necessiten resultats constants i fiables',
    planPlusDescription: 'Consulta més cites, amb prioritat i major velocitat de resposta.',
    planPlusHighlight: 'Equilibri perfecte entre rendiment i cost',
    planPlusTrust: 'Sense límits ocults ni sorpreses.',
    planProSubtitle: 'La millor opció per a professionals actius',
    planProDescription: 'Dissenyat per metges que volen accés il·limitat, assistència prioritària i la màxima fiabilitat.',
    planProHighlight: 'Ideal per a presentacions, investigacions i ús clínic habitual',
    planProTrust: 'Confiança i rendiment professional, cada dia.',
    
    // Landing page
    landingNav: {
      login: 'Iniciar Sessió',
      plans: 'Plans',
    },
    landingHero: {
      badge: 'IA per a professionals mèdics',
      title: 'Troba cites mèdiques en',
      titleHighlight: 'segons',
      titleEnd: ', no hores',
      subtitle: 'Escriu una afirmació i obtén articles i resums fiables en segons.',
      ctaPrimary: 'Comença Ara – Gratuït',
      ctaSecondary: 'Veure Com Funciona',
    },
    landingTrust: {
      text: 'Confiada per milers de metges en tot el món',
    },
    landingCalculator: {
      title: 'Calcula el Teu Estalvi de Temps',
      subtitle: 'Descobreix quant temps pots recuperar amb MedAI Cite',
      searchesLabel: 'Quantes cites fas a la setmana?',
      searchesPlaceholder: 'Exemple: 15',
      minutesLabel: 'Quants minuts trigues per cita?',
      minutesPlaceholder: 'Exemple: 15',
      minutesSaved: 'minuts estalviats per setmana',
      freeTime: 'temps lliure per setmana',
      hoursSaved: 'hores estalviades al mes',
      noData: 'Encara no hi ha prou dades per calcular l\'estalvi.',
      tryHigher: 'Prova amb valors més alts per veure els resultats.',
    },
    landingBenefits: {
      title: 'Estalvia temps i millora la qualitat de la teva recerca amb IA mèdica',
      subtitle: 'Tecnologia d\'intel·ligència artificial dissenyada per professionals de la salut',
      benefit1Title: 'Cites Automàtiques',
      benefit1Desc: 'Genera cites en format Vancouver o APA automàticament des de múltiples bases de dades mèdiques.',
      benefit2Title: 'Fonts Fiables',
      benefit2Desc: 'Accedeix a PubMed, Semantic Scholar i CrossRef per obtenir la millor evidència científica.',
      benefit3Title: 'Exportació Fàcil',
      benefit3Desc: 'Exporta les teves cites en múltiples formats i integra-les directament als teus treballs.',
      benefit4Title: 'Evita Errors',
      benefit4Desc: 'Redueix errors de citació i assegura\'t que totes les referències són precises i actualitzades.',
      testimonialQuote: '"Amb MedAI Cite puc revisar estudis en minuts, no hores."',
      testimonialAuthor: '— Dra. M. López, Barcelona',
    },
    landingHowItWorks: {
      subtitle: 'De la idea al resultat en tres passos',
      title: 'Com Funciona?',
      description: 'Només tres passos per trobar les cites que necessites',
      step1Title: 'Descriu el que busques',
      step1Desc: 'Escriu la teva pregunta clínica o àrea de recerca en llenguatge natural.',
      step2Title: 'IA troba les millors fonts',
      step2Desc: 'La nostra IA busca en múltiples bases de dades mèdiques simultàniament.',
      step3Title: 'Exporta i cita',
      step3Desc: 'Obté les cites en el format que necessites i exporta-les al teu document.',
    },
    landingDemo: {
      title: 'Exemple en acció',
      exampleQuery: 'La luxació de pròtesi de maluc té una freqüència considerable.',
      badge: 'Exemple real — prova-ho amb la teva cerca',
      ctaButton: 'Prova-ho amb la teva cerca →',
    },
    landingCta: {
      title: 'Comença a Estalviar Temps Avui',
      subtitle: 'Uneix-te a milers de professionals mèdics que ja utilitzen MedAI Cite per millorar la seva recerca',
      button: 'Comença Ara – Gratuït',
    },
    landingFooter: {
      copyright: '© 2025 ActuaAI — Tots els drets reservats',
      contact: 'Contacta amb nosaltres',
      developedBy: 'Projecte desenvolupat per ActuaAI per donar suport als professionals mèdics.',
    },
    trustIndicators: {
      heroSubtext: 'Confiat per estudiants i professionals en 20+ països.',
      demoSubtext: 'Creat amb el suport d\'estudiants de medicina i metges en actiu.',
      usageCounter: '🔍 12.500 cerques realitzades aquest mes.',
      designedForTitle: 'Dissenyat per a...',
      forWhoTitle: 'Per a qui és?',
      audience1: 'Estudiants de medicina',
      audience2: 'Metges residents',
      audience3: 'Metges especialistes',
      audience4: 'Investigadors i docents',
      finalText: 'Ideal per a presentacions, treballs clínics i revisió ràpida d\'evidència.',
    },
  },
};
